import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { TodayPlan } from '../types/today';
import { TaskRow } from './TaskRow';
import AddIcon from '@mui/icons-material/Add';

interface TodayViewProps {
  plan: TodayPlan;
  onTaskToggle?: (taskId: string) => void;
  onAddTask?: (sectionId: string) => void;
}

export const TodayView: React.FC<TodayViewProps> = ({ plan, onTaskToggle, onAddTask }) => {
  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', py: 4, px: 3 }}>
      {/* Header */}
      <Typography
        variant="h4"
        component="h1"
        sx={{
          fontWeight: 600,
          mb: 4,
          color: 'text.primary',
        }}
      >
        Today
      </Typography>

      {/* Sections */}
      {plan.sections.map((section) => (
        <Box key={section.id} sx={{ mb: 4 }}>
          {/* Section title */}
          <Typography
            variant="overline"
            sx={{
              fontWeight: 600,
              color: 'text.secondary',
              display: 'block',
              mb: 1.5,
              letterSpacing: 0.5,
            }}
          >
            {section.title}
          </Typography>

          {/* Task list */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
            {section.tasks.map((task) => (
              <TaskRow key={task.id} task={task} onToggle={onTaskToggle} />
            ))}
          </Box>

          {/* Add task button - only for "My Projects" section */}
          {section.id === 'my-projects' && (
            <Button
              startIcon={<AddIcon />}
              onClick={() => onAddTask?.(section.id)}
              sx={{
                mt: 1,
                color: 'text.secondary',
                textTransform: 'none',
                fontWeight: 400,
                justifyContent: 'flex-start',
                pl: 1,
                '&:hover': {
                  bgcolor: 'action.hover',
                  color: 'error.main',
                },
              }}
              fullWidth
            >
              Add task
            </Button>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default TodayView;
